import { Component, OnInit, OnDestroy, ViewChildren, QueryList, ElementRef, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';

interface TechSlide {
  title: string;
  image: string;
}

@Component({
  selector: 'app-suite-technologies',
  imports: [CommonModule],
  templateUrl: './suite-technologies.component.html',
  styleUrls: ['./suite-technologies.component.scss'],
  standalone: true
})
export class SuiteTechnologiesComponent implements OnInit, OnDestroy, AfterViewInit {
  currentSlide = 0;
  private autoSlideInterval: any;

  @ViewChildren('videoPlayer') videoElements!: QueryList<ElementRef<HTMLVideoElement>>;

  slides: TechSlide[] = [
    { title: 'FRONT END', image: '../../../assets/home/technologies/slider-images/frontend.webm' },
    { title: 'BACK END', image: '../../../assets/home/technologies/slider-images/backend.webm' },
    { title: 'AI & ML', image: '../../../assets/home/technologies/slider-images/artificialintelligence.webm' },
    { title: 'DATABASE', image: '../../../assets/home/technologies/slider-images/database.webm' },
    { title: 'MOBILE APPS', image: '../../../assets/home/technologies/slider-images/mobileapp.webm' },
    { title: 'DEVOPS', image: '../../../assets/home/technologies/slider-images/devops.webm' },
    { title: 'QA', image: '../../../assets/home/technologies/slider-images/qa.webm' },
    { title: 'CLOUD', image: '../../../assets/home/technologies/slider-images/cloud.webm' }
  ];

  ngOnInit(): void {
    // We start auto slide after view init to ensure videos are ready
  }

  ngAfterViewInit(): void {
    // Slight delay to ensure DOM is ready before playing first video
    setTimeout(() => {
      this.updateVideoPlayback();
      this.startAutoSlide();
    }, 100);
  }

  ngOnDestroy(): void {
    this.stopAutoSlide();
  }

  startAutoSlide(): void {
    this.stopAutoSlide(); // Clear any existing interval
    this.autoSlideInterval = setInterval(() => {
      this.nextSlide();
    }, 5000);
  }

  stopAutoSlide(): void {
    if (this.autoSlideInterval) {
      clearInterval(this.autoSlideInterval);
    }
  }

  nextSlide(): void {
    this.currentSlide = (this.currentSlide + 1) % this.slides.length;
    this.updateVideoPlayback();
  }

  goToSlide(index: number): void {
    this.currentSlide = index;
    this.updateVideoPlayback();
    // Restart timer when user interacts
    this.startAutoSlide();
  }

  private updateVideoPlayback(): void {
    if (!this.videoElements) return;

    const videos = this.videoElements.toArray();

    videos.forEach((videoRef, index) => {
      const video = videoRef.nativeElement;

      if (index === this.currentSlide) {
        // 1. Force reset time to start
        video.currentTime = 0;

        // 2. Since we set preload="none", we must manually load if not ready
        // readyState 0 means HAVE_NOTHING
        if (video.readyState === 0) {
          video.load(); 
        }

        // 3. Play
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(error => {
            console.warn('Auto-play was prevented:', error);
          });
        }
      } else {
        // Pause others and reset their time so they are ready next time
        video.pause();
        video.currentTime = 0; 
      }
    });
  }
}